/* IRiller | カートのセット数量連動・表示順制御
   _ir_bundle_id の数量連動を維持し、表示順のみ整理する。 */
(() => {
  'use strict';
  if (window.__irCartBundleStarted) return;
  window.__irCartBundleStarted = true;
  const rootPath = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const url = (path) => rootPath + path;
  let busy = false;
  let timer;
  let observer;
  function arrangeRows(cart) {
    const tbody = document.querySelector('#main-cart-items .cart-items tbody');
    if (!tbody || !cart?.items) return;
    const rows = Array.from(tbody.querySelectorAll(':scope > tr.cart-item'));
    if (rows.length !== cart.items.length) return;
    const records = rows.map(row => {
      const match = /^CartItem-(\d+)$/.exec(row.id);
      const index = match ? Number(match[1]) - 1 : -1;
      return { row, item: cart.items[index], index };
    });
    if (records.some(record => !record.item)) return;
    const mains = records.filter(({ item }) => {
      const p = item.properties || {};
      return !String(item.sku || '').startsWith('OP-') && p._ir_bundle_role !== 'addon';
    });
    const options = records.filter(({ item }) => {
      const p = item.properties || {};
      return String(item.sku || '').startsWith('OP-') || p._ir_bundle_role === 'addon';
    });
    const used = new Set();
    const desired = [];
    for (const main of mains) {
      desired.push(main.row);
      used.add(main.row);
      const mainProps = main.item.properties || {};
      const bundleId = mainProps._ir_bundle_role === 'main' ? mainProps._ir_bundle_id : null;
      const embroideryId = mainProps['刺繍連携ID'];
      for (const option of options) {
        if (used.has(option.row)) continue;
        const p = option.item.properties || {};
        const isBundleAddon = bundleId && p._ir_bundle_id === bundleId && p._ir_bundle_role === 'addon';
        const isEmbroidery = String(option.item.sku || '').startsWith('OP-EM');
        const isLinkedEmbroidery = !bundleId && embroideryId && isEmbroidery && p['刺繍連携ID'] === embroideryId;
        if (isBundleAddon || isLinkedEmbroidery) {
          desired.push(option.row);
          used.add(option.row);
        }
      }
    }
    for (const option of options) {
      if (!used.has(option.row)) {
        desired.push(option.row);
        used.add(option.row);
      }
    }
    for (const record of records) {
      if (!used.has(record.row)) desired.push(record.row);
    }
    if (desired.every((row, index) => rows[index] === row)) return;
    const fragment = document.createDocumentFragment();
    desired.forEach(row => fragment.appendChild(row));
    tbody.appendChild(fragment);
  }
  async function getCart() {
    const response = await fetch(url('cart.js'), { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('カート情報を取得できませんでした');
    return response.json();
  }
  async function reconcile() {
    if (busy || !document.querySelector('#main-cart-items')) return;
    busy = true;
    try {
      const cart = await getCart();
      const parents = new Map();
      for (const item of cart.items) {
        const p = item.properties || {};
        if (p._ir_bundle_id && p._ir_bundle_role === 'main') parents.set(p._ir_bundle_id, item);
      }
      const changes = {};
      for (const item of cart.items) {
        const p = item.properties || {};
        if (!p._ir_bundle_id || p._ir_bundle_role !== 'addon') continue;
        const parent = parents.get(p._ir_bundle_id);
        const perMain = Number(p._ir_bundle_per_main);
        if (!Number.isSafeInteger(perMain) || perMain < 1) continue;
        const expected = parent ? parent.quantity * perMain : 0;
        if (item.quantity !== expected) changes[item.key] = expected;
      }
      if (Object.keys(changes).length) {
        const response = await fetch(url('cart/update.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ updates: changes })
        });
        if (!response.ok) throw new Error('装飾の数量を更新できませんでした');
        window.location.reload();
        return;
      }
      arrangeRows(cart);
    } catch (error) {
      console.error('[IR Cart Bundle]', error);
      const area = document.querySelector('#main-cart-items');
      if (area && !area.querySelector('.ir-cart-bundle-error')) {
        const message = document.createElement('p');
        message.className = 'ir-cart-bundle-error';
        message.setAttribute('role', 'alert');
        message.style.cssText = 'color:#b3261e;font-size:12px;line-height:1.7;margin:10px 0';
        message.textContent = 'カート内のオプション情報を確認できませんでした。ページを再読み込みしてください。';
        area.prepend(message);
      }
    } finally {
      busy = false;
    }
  }
  function schedule(delay = 850) {
    clearTimeout(timer);
    timer = setTimeout(reconcile, delay);
  }
  function start() {
    schedule(100);
    const target = document.querySelector('#main-cart-items');
    if (target) {
      observer = new MutationObserver(records => {
        const changed = records.some(record => record.type === 'childList' && Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches?.('.js-contents, .cart-items, .cart-item') || node.querySelector?.('.cart-item'))));
        if (changed) schedule(250);
      });
      observer.observe(target, { childList: true, subtree: true });
    }
    document.addEventListener('change', event => {
      if (event.target.closest?.('#main-cart-items .quantity__input')) schedule(1100);
    });
    document.addEventListener('click', event => {
      if (event.target.closest?.('#main-cart-items cart-remove-button, #main-cart-items .quantity__button')) schedule(1100);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
